import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { Act48Api } from './act48.api';
import { AutoAssignmentApi } from './auto-assignment.api';
import { ComplianceItemApi } from './compliance-item.api';
import { ComplyMessageApi } from './comply-message.api';
import { EdlPubSubLogApi } from './edl-pub-sub-log/edl-pub-sub-log.api';
import { FileApi } from './file.api';
import { GroupApi } from './group.api';
import { ItemPacketApi } from './item-packet/item-packet.api';
import { MetricApi } from './metric.api';
import { NoteApi } from './note.api';
import { OnboardingApi } from './onboarding.api';
import { QuestionnaireApi } from './questionnaire.api';
import { RegistrationApi } from './registration.api';
import { RequestItemApi } from './request-item.api';
import { VerifyRequestApi } from './request-verify.api';
import { RosterPreferenceApi } from './roster-preference.api';
import { TagApi } from './tag.api';
import { UserCycleApi } from './user-cycle.api';
import { UserRequestApi } from './user-request.api';
import { VerifyApi } from './verify.api';
import { VolunteerReportApi } from './volunteer-report.api';
import { ReportsApi } from './reports/reports.api';

@NgModule({
    imports: [
        CommonModule
    ],
    providers: [
        Act48Api,
        AutoAssignmentApi,
        ComplianceItemApi,
        ComplyMessageApi,
        EdlPubSubLogApi,
        FileApi,
        GroupApi,
        ItemPacketApi,
        MetricApi,
        NoteApi,
        OnboardingApi,
        QuestionnaireApi,
        RegistrationApi,
        ReportsApi,
        RequestItemApi,
        RosterPreferenceApi,
        TagApi,
        UserCycleApi,
        UserRequestApi,
        VerifyApi,
        VerifyRequestApi,
        VolunteerReportApi
    ]
})
export class ApiModule { }